export class MeshRegistry {
    meshes = new Map();
    loaders = new Map();
    loadingPromises = new Map();
    registerLoader(loader, extensions) {
        extensions.forEach((ext) => this.loaders.set(ext, loader));
    }
    get(meshName) {
        return this.meshes.get(meshName);
    }
    // eslint-disable-next-line require-await
    async load(meshName, url, gl) {
        // Check cache
        if (this.meshes.has(url)) {
            return this.meshes.get(url);
        }
        // Check if already loading
        if (this.loadingPromises.has(url)) {
            return this.loadingPromises.get(url);
        }
        // Start loading
        const extension = this.getExtension(url);
        const loader = this.loaders.get(extension);
        if (!loader) {
            throw new Error(`No loader for ${extension}`);
        }
        const promise = loader.load(meshName, url, gl).then((mesh) => {
            if (!mesh) {
                throw new Error(`Failed to load mesh from ${url}`);
            }
            this.meshes.set(meshName, mesh);
            this.loadingPromises.delete(url);
            return mesh;
        });
        this.loadingPromises.set(url, promise);
        return promise;
    }
    getExtension(url) {
        return url.substring(url.lastIndexOf('.'));
    }
}
